import { useMemo, useState } from "react";

const SIZES = {
  sm: ["h-8 w-8", "text-xs"],
  md: ["h-10 w-10", "text-sm"],
};

export function Avatar({ name, avatarUrl, size = "md", className = "" }) {
  const [broken, setBroken] = useState(false);

  const initials = useMemo(() => {
    if (!name) return "?";
    return (
      name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((s) => s[0]?.toUpperCase())
        .join("") || "?"
    );
  }, [name]);

  const [sizeClass, textClass] = SIZES[size] || SIZES.md;
  const showImage = avatarUrl && !broken;

  return showImage ? (
    <img
      src={avatarUrl}
      alt={name}
      className={`${sizeClass} rounded-full object-cover ring-1 ring-border-light ${className}`}
      loading="lazy"
      decoding="async"
      onError={() => setBroken(true)}
    />
  ) : (
    <div
      className={`${sizeClass} rounded-full bg-surface-muted dark:bg-surface-darker text-text-secondary flex items-center justify-center ${textClass} font-semibold ring-1 ring-border-light ${className}`}
    >
      {initials}
    </div>
  );
}
